import type { Catalog } from '../types';

export const auth = {
  'auth.login.title': { pt: 'Entrar', en: 'Sign in' },
  'auth.login.submit': { pt: 'Entrar', en: 'Sign in' },
  'auth.login.failed': { pt: 'Não foi possível entrar', en: 'Could not sign in' },
  'auth.login.badCredentials': {
    pt: 'Email ou senha incorretos',
    en: 'Wrong email or password',
  },
  'auth.login.noAccount': { pt: 'Não tem conta?', en: 'No account?' },

  'auth.register.title': { pt: 'Criar conta', en: 'Create account' },
  'auth.register.submit': { pt: 'Criar conta', en: 'Create account' },
  'auth.register.failed': { pt: 'Não foi possível criar a conta', en: 'Could not create the account' },
  'auth.register.emailTaken': { pt: 'Este email já tem uma conta', en: 'That email already has an account' },
  'auth.register.emailInvalid': { pt: 'Email inválido', en: 'Invalid email' },
  'auth.register.hasAccount': { pt: 'Já tem conta?', en: 'Already have an account?' },

  'auth.field.email': { pt: 'Email', en: 'Email' },
  'auth.field.password': { pt: 'Senha', en: 'Password' },
  'auth.field.displayName': { pt: 'Nome de exibição', en: 'Display name' },

  'auth.sameAccount': {
    pt: 'Use a mesma conta do relógio',
    en: 'Use the same account as the watch',
  },
  'auth.sameAccountHint': {
    pt: 'Mesma conta do aplicativo do relógio',
    en: 'Same account as the watch app',
  },
  'auth.back': { pt: 'Voltar', en: 'Back' },

  'auth.missing.email': { pt: 'Informe seu email', en: 'Enter your email' },
  'auth.missing.password': { pt: 'Informe sua senha', en: 'Enter your password' },
  'auth.waitAMinute': {
    pt: 'Aguarde um minuto antes de tentar de novo.',
    en: 'Wait a minute before trying again.',
  },
  'auth.tooManyAttempts': { pt: 'Muitas tentativas', en: 'Too many attempts' },
  'auth.forgotPassword': { pt: 'Esqueci minha senha', en: 'I forgot my password' },
  'auth.oauth.google': { pt: 'Continuar com Google', en: 'Continue with Google' },
  'auth.oauth.apple': { pt: 'Continuar com Apple', en: 'Continue with Apple' },

  'auth.hero.line1': { pt: 'O relógio registra.', en: 'The watch records.' },
  'auth.hero.line2': { pt: 'Aqui você entende.', en: 'Here you understand.' },
  'auth.hero.blurb': {
    pt: 'Scorecard completo, evolução de handicap e o campo buraco a buraco.',
    en: 'Full scorecard, handicap over time, and the course hole by hole.',
  },
  'auth.sessionRevoked': {
    pt: 'Sua sessão foi encerrada em todos os dispositivos por segurança. Entre de novo para continuar.',
    en: 'Your session was ended on every device for security. Sign in again to continue.',
  },
  'auth.noPasswordReset': {
    pt: 'A recuperação de senha ainda não existe no servidor — não há endpoint para ela. Por ora, entre pelo relógio ou crie uma conta nova.',
    en: 'Password recovery does not exist on the server yet — there is no endpoint for it. For now, sign in from the watch or create a new account.',
  },
  'auth.oauth.notConfigured': {
    pt: 'Login social ainda não está configurado no servidor. Use email e senha — é a mesma conta do relógio.',
    en: 'Social sign-in is not configured on the server yet. Use email and password — it is the same account as the watch.',
  },
  'auth.oauth.appleNotConfigured': {
    pt: 'Login com Apple ainda não está configurado. É a mesma conta do relógio.',
    en: 'Sign in with Apple is not configured yet. It is the same account as the watch.',
  },
  'auth.passwordMin': {
    pt: 'Mínimo de {min} caracteres',
    en: 'At least {min} characters',
  },

  'auth.sessionExpired': {
    pt: 'Sua sessão expirou. Entre de novo para continuar de onde parou.',
    en: 'Your session expired. Sign in again to pick up where you left off.',
  },
  'auth.offline': {
    pt: 'Sem conexão com o servidor. Verifique sua internet e tente de novo.',
    en: 'No connection to the server. Check your internet and try again.',
  },
} as const satisfies Catalog;
